export default {
  install(Vue, options) {
    Vue.prototype.$loopo = function (object, iterator) {
      //
      /* Correct Usage example:
        this.$loopo(this.form, (value, key, object) => {
          this.setFormField(key, company[key]);
        });
       */
      /* INCORRECT! Usage example:
        this.$loopo(this.form, function(value, key, object) {
          this.setFormField(key, company[key]);
          ^^^^ this won't work correctly if you do it this way.
        });
       */
      if (typeof object !== 'object') return;

      let prop;
      for (prop in object) {
        if (object.hasOwnProperty(prop)) {
          iterator(object[prop], prop, object);
        }
      }
    };
  }
};
